// extracted by mini-css-extract-plugin
export default {"spinner":"loader_spinner__jDssK","sk-bouncedelay":"loader_sk-bouncedelay__Q0s70","bounce1":"loader_bounce1__lYLmX","bounce2":"loader_bounce2__u+yA-"};